<template>
  <div class="input">
    <p v-if="type !== 'submit'">{{placeholder}}</p>
    
    <input 
      :type="type"
      :placeholder="placeholder"
      :value="value"
      v-model="inputVal"
      :required="checkRequired ? false : true"
      data-date-format="DD MMMM YYYY"
      min="0"
      v-on:focus="$emit('handleFocus')"
      v-on:keyup="$emit('handleKeyup')"
      v-on:keyup.enter="$emit('handleKeyupEnter')"
    />
  </div>
</template>

<script>
  export default {
    name: 'Input',
    props: [
      'placeholder',
      'type',
      'value'
    ],
    data() {
      return { inputVal: this.value }
    },
    methods: {
      checkRequired: function() {
        if (this.type === 'file') {
          return false;
        } else {
          return true;
        }
      }
    },
    watch: {
      inputVal(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss">
  .input {
    p {
      font-weight: bold;
      padding-bottom: 15px;
    }

    .images--item {
      margin-bottom: 15px;
      border: 1px solid var(--grey-light);
    }

    span {
      display: block;
      margin-bottom: 15px;
    }

    .tag--input,
    .tag--list {
      margin-bottom: 15px;
    }
    
    input[type=password],
    input[type=email],
    input[type=text],
    input[type=name],
    input[type=date],
    input[type=datetime-local],
    input[type=number] {
      -webkit-appearance: none;    
      -moz-appearance: none;
      -ms-appearance: none;
      appearance: none;
      outline: 0;
      border: 1px solid var(--blue-medium);
      height: 30px;
      width: 100%;
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      margin-bottom: 15px;
    }

    input[type=file],
    select {
      margin-bottom: 15px;
    }

    input[type=submit] {
      display: inline-block;
      border-radius: 3px;
      box-sizing: border-box;
      padding: 7px 10px; 
      border: 0;
      cursor: pointer;
      background: var(--blue);
      color: var(--white);
      font-weight: normal;
      transition: 0.2s;
      font-size: 14px;
      height: 30px;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .row {

    input[type=password],
    input[type=email],
    input[type=text] {
      width: 100%;
      max-width: 100%;
    }
  }

  textarea {
    width: 100%;
    height: 100px;
    margin-bottom: 13px;
    padding: 10px;
    border: 1px solid var(--blue-medium);
    outline: 0;
  }
</style>